module.exports = __webpack_public_path__ + "img/activity_rule.1775439203884.png";